import { render, staticRenderFns } from "./GiftSelect.vue?vue&type=template&id=40d15ed4&scoped=true&"
import script from "./GiftSelect.vue?vue&type=script&lang=js&"
export * from "./GiftSelect.vue?vue&type=script&lang=js&"
import style0 from "./GiftSelect.vue?vue&type=style&index=0&id=40d15ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d15ed4",
  null
  
)

export default component.exports